import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "type"];
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { jsx as _jsx } from "react/jsx-runtime";
export const handleClose = (message, onClose) => {
  const hasResponseJSON = message && message.error && message.error.responseJSON;
  if (message && message.error === 'IFrame initialization failed') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.errorInitFailed"
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'saveLineItemsError') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.saveLineItemsError"
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'ASSOCIATION_LIMIT_EXCEEDED_CREATOR') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "lib.creatorAssociationLimitExceededError",
        options: {
          objectName: message.objectName,
          toObjectName: message.toObjectName,
          limit: /*#__PURE__*/_jsx(FormattedNumber, {
            value: message.limit ? +message.limit : 50000
          })
        }
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'USER_DOES_NOT_HAVE_PERMISSION') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.noPermissionsToAssociate"
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'associationCreateFailures') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.associationCreateFailures",
        options: {
          objectName: message.objectName
        }
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'marketableContactAssociationError') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.marketableContactAssociationError"
      }),
      type: 'danger'
    });
    return;
  }
  if (hasResponseJSON && message.error.responseJSON.errorType === 'LimitExceededException') {
    const limit = message.error.responseJSON.errorTokens.limit[0];
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "lib.createLimitExceededError",
        options: {
          limit: /*#__PURE__*/_jsx(FormattedNumber, {
            value: Number(limit)
          }),
          objectName: message.objectName
        }
      }),
      type: 'danger'
    });
    return;
  }
  if (hasResponseJSON && message.error.responseJSON.message === 'ASSOCIATION_LIMIT_EXCEEDED') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.associationLimitExceededError",
        options: {
          fromObjectName: message.fromObjectName,
          toObjectName: message.objectName
        }
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'CRM_OBJECT_NOT_FOUND' || hasResponseJSON && message.error.responseJSON.message === 'CRM_OBJECT_NOT_FOUND') {
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "lib.associatorNoObjectFound",
        options: {
          objectName: message.objectName
        }
      }),
      type: 'danger'
    });
    return;
  }
  if (message && message.error === 'ASSOCIATION_USER_CONFIG_LIMIT_EXCEEDED' || hasResponseJSON && message.error.responseJSON.message === 'ASSOCIATION_USER_CONFIG_LIMIT_EXCEEDED') {
    if (message.specHasAllAssociatedObjects) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associationUserConfigLimitExceededError"
        }),
        type: 'danger'
      });
    } else {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associationUserConfigLabelLimitExceededError"
        }),
        type: 'danger'
      });
    }
    return;
  }
  if (message && message.alert) {
    const _message$alert = message.alert,
      {
        message: alertMessage,
        type
      } = _message$alert,
      rest = _objectWithoutPropertiesLoose(_message$alert, _excluded);
    FloatingAlertStore.addAlert(Object.assign({
      message: alertMessage,
      type,
      'data-alert-type': type
    }, rest));
    return;
  }
  onClose(message);
};